import React, {Fragment, useEffect} from "react";
import {useConfigureNotebook} from "../../../../../../../hooks/use-notebook-config";
import Grid2 from "@mui/material/Unstable_Grid2";
import useBehavioralAnalyticsTool from "../../../../../../../hooks/use-behavioural-analytics-tool";
import useAccessLevels from "../../../../../../../hooks/use-access-levels";
import {DynamicOrganizationalConfigurationsSection} from "./dynamic-organizational-configurations";
import {NexusSearchConfigurationsSection} from "./nexus-search-configurations";
import {SalesConfigurationsSection} from "./sales-configurations";
import {ClientPlatformConfigurationsSection} from "./client-platform-configurations";
import {AccountingSystemCredentialsConfigurationsSection} from "./accounting-system-credentials-configurations";
import {PaymentProvidersConfigurationsSection} from "./payment-providers-configurations";
import {PartnerColorThemeConfigurationsSection} from "./partner-color-theme-configurations";
import {FreightSettingsConfigurationsSection} from "./freight-settings-configurations";
import {CustomerDefaultPropertiesConfigurationsSection} from "./customer-default-properties-configurations";


const OrganizationalConfigurationsView = () => {
    const {configureNotebookTags} = useConfigureNotebook('organizational-configurations-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();
    const operatorAccessLevels = useAccessLevels();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool for the view
     */
    useEffect(() => {
        configureNotebookTags((noteTags) => noteTags.settingsOrganization);
        configureBehavioralTool((tags) => tags.settingsOrganization);
    }, [configureBehavioralTool, configureNotebookTags]);

    return (
        <>
            <Grid2 container spacing={4}>
                {
                    operatorAccessLevels.packages.base.accountingSystemSettings &&
                    <AccountingSystemCredentialsConfigurationsSection/>
                }
                {
                    operatorAccessLevels.packages.base.paymentProvidersSettings &&
                    <PaymentProvidersConfigurationsSection/>
                }
                {
                    operatorAccessLevels.packages.base.partnerColorThemeSettings &&
                    <PartnerColorThemeConfigurationsSection/>
                }
                {
                    operatorAccessLevels.packages.base.retailUserSettings &&
                    <ClientPlatformConfigurationsSection/>
                }
                {
                    operatorAccessLevels.packages.base.freightProviderSettings &&
                    <FreightSettingsConfigurationsSection/>
                }
                <CustomerDefaultPropertiesConfigurationsSection/>
                <DynamicOrganizationalConfigurationsSection/>
                <NexusSearchConfigurationsSection/>
                <SalesConfigurationsSection/>
            </Grid2>
        </>
    );
}

export default OrganizationalConfigurationsView;